/* src/app/components/doc-viewer-new/dialogs/email-edit/email-edit.component.scss */
[dialog-body] {
  color: var(--text-color);
}
:host-context(.dark-theme) [dialog-body] {
  color: var(--text-color);
}
textarea {
  background-color: rgba(252, 252, 252, 0.6862745098);
  border: 1px solid #243e90;
  border-radius: 5px;
  padding: 8px;
  outline: none;
  color: inherit;
  background: inherit;
  width: 100%;
  margin-right: 10px;
  font: inherit;
  transition: box-shadow 0.2s;
}
textarea:focus {
  background-color: rgba(252, 252, 252, 0.6862745098);
  border-color: #283593;
  box-shadow: 0 0 3px rgba(40, 52, 147, 0.6862745098);
}
.item-row {
  display: flex;
  justify-content: space-between;
  height: 48px;
  padding-left: 6px;
  transition: background-color 0.3s ease;
}
.item-row:hover {
  background-color: rgba(57, 73, 171, 0.08);
}
.item-row:hover .edit-button {
  display: inline-flex;
}
.item-row:not(.last-item) {
  border-bottom: 1px solid #e0e0e0;
}
.edit-button {
  display: none;
}
.list-container {
  background-color: rgba(211, 211, 211, 0.3019607843);
}
:host-context(.dark-theme) textarea {
  border: 1px solid rgba(255, 255, 255, 0.1882352941);
  border-radius: 5px;
  padding: 8px;
  outline: none;
  color: inherit;
  background: inherit;
  transition: box-shadow 0.2s;
}
:host-context(.dark-theme) textarea:focus {
  border-color: #D0A010;
  box-shadow: 0 0 3px #b18a16;
}
:host-context(.dark-theme) .item-row:hover {
  background-color: rgba(0, 0, 0, 0.32);
}
:host-context(.dark-theme) .item-row:not(.last-item) {
  border-bottom: 1px solid rgba(138, 138, 138, 0.6588235294);
}
:host-context(.dark-theme) .list-container {
  background-color: #2E2E2E;
}
/*# sourceMappingURL=email-edit.component.css.map */
